import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { DataConnectService } from 'src/app/services/data-connect.service'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  username: number;
  password: string;
  error: any;
  returnUrl: string;
  token: any;
  env = environment;
  timer: any;
  alertvisible: boolean;

  constructor(private route: ActivatedRoute, private router: Router, public _authService: AuthService,
    private actvaterouter: ActivatedRoute , private Data: DataConnectService) {

    this.actvaterouter.params.subscribe(params => {


      this.token = params['token'];
      Data.setTokenOficial(this.token)
      if (this.token) {

        this.login(this._authService.logintoken(this.token));
      }

    });
  }

  ngOnInit() {
     if (this._authService.getToken()) {
      this.router.navigate(['/inicio']);
    }


    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/inicio';

  }


// login() {
//   this._authService.attemptAuth(this.username, this.password)
//   .subscribe(
//     data => {

//       console.log(data);
//       this.router.navigate(['home']);
//     }
//   );
// }

login(usr) {
  //console.log(this.username);
//this.alertvisible = true;
//   setTimeout (() => {
//     this.alertvisible =false;
//  }, 4000);

  if (!usr) {
    usr = this.username;
  }
  this._authService.attemptAuth(usr, this.password)
    .subscribe(
      (data => {

        if (this.returnUrl === 'login') {
          this.router.navigate([this.returnUrl]);
        } else {
          this.router.navigate([this.returnUrl]);

        }
      }),
      error => this.error = error // error path
    );
}


}
